import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="w-full bg-gradient-to-br from-[#e9f2fc] to-[#d0e7f9] flex items-center min-h-screen">
      <div className="w-full mx-auto px-6 md:px-4 sm:px-2 md:pt-8 sm:pt-24 grid md:grid-cols-2 grid-cols-2 sm:grid-cols-1 items-center gap-8">
        {/* Text Content */}
        <div className="space-y-4 text-left text-black px-8">
          <div className="inline-block bg-textBlue text-white text-sm px-4 py-1 rounded-full mb-0">
            {t("hero.subtitle")}
          </div>
          <h1 className="text-5xl md:text-3xl sm:text-3xl font-bold leading-tight max-w-xl mb-2">
            {t("hero.title")}
          </h1>
          <p className="text-2xl md:text-lg font-semibold text-textBlue max-w-xl mb-2">
            {t("hero.tagline")}
          </p>
          <p className="text-xl md:text-sm max-w-xl leading-normal text-gray-700">
            {t("hero.description")}
          </p>
          <button
            className="bg-textBlue px-6 py-3 rounded-full outline-none text-white hover:bg-textBlueDark transition mb-0"
            onClick={() => navigate("/solutions")}
          >
            {t("hero.button")}
          </button>
        </div>

        {/* Hero Image */}
        <div className="flex justify-end pt-20 md:pt-4 sm:pt-0">
          <img
            src="/bagorund.svg"
            alt="Hero Background"
            className="w-full h-auto max-w-[500px] md:max-w-[350px]"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
